"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
var BlockTrackerErrorCode;

(function (BlockTrackerErrorCode) {
  // Block data was not found after retries
  BlockTrackerErrorCode[BlockTrackerErrorCode["BlockNotFound"] = 3000] = "BlockNotFound";
})(BlockTrackerErrorCode = exports.BlockTrackerErrorCode || (exports.BlockTrackerErrorCode = {}));
/**
 * Represents errors that occur in the block tracker
 */


var BlockTrackerError =
/** @class */
function (_super) {
  __extends(BlockTrackerError, _super);

  function BlockTrackerError(message, code) {
    var _this = _super.call(this, message) || this; // Maintains proper stack trace for where our error was thrown (only available on V8)


    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this, BlockTrackerError);
    }

    _this.code = code;
    return _this;
  }

  BlockTrackerError.BlockNotFound = function (blockNumber) {
    return new BlockTrackerError("Could not load block " + blockNumber, BlockTrackerErrorCode.BlockNotFound);
  };

  return BlockTrackerError;
}(Error);

exports.BlockTrackerError = BlockTrackerError;